export var Api_AdPlacementType;
(function (Api_AdPlacementType) {
    Api_AdPlacementType["PREROLL"] = "preroll";
    Api_AdPlacementType["INTERSTITIAL"] = "interstitial";
    Api_AdPlacementType["DISPLAY"] = "display";
    Api_AdPlacementType["OUTSTREAM"] = "outstream";
    Api_AdPlacementType["RM_INFEED"] = "rm_infeed";
})(Api_AdPlacementType || (Api_AdPlacementType = {}));
